(ns ui.view.card.value-creations.event 
  (:require
   [frontend.controller.websocket.event :as ws]
   [re-frame.core :as rf]
   [ui.cofx.response :as response-cofx]
   [ui.view.card.event :as common-event]))

(rf/reg-event-fx
 ::refetch-data
 [rf/trim-v]
 (fn [_ [ctx]]
   (let [event (common-event/create-fetch-card-data-event (assoc ctx :reset-entities? true))]
     {:fx [[:dispatch event]]})))

(rf/reg-event-fx
 ::delete-value-creation-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [_]} [ctx]]
   (js/console.log "Delete value creation successful")
   {:fx [[:dispatch [::refetch-data ctx]]
         [:dispatch [::common-event/close-entity-peek ctx]]]}))

(rf/reg-event-fx
 ::delete-value-creation-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx resp]]
   ;; TODO: Handle error
   (js/console.error "Delete value creation failed " resp)))

(rf/reg-event-fx
 ::delete-value-creation
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [_] :as ctx} value-creation-id]]
   {::ws/send {:id :entity/disable!
               :body {:entity-id value-creation-id}
               :on-success [::delete-value-creation-success ctx]
               :on-error [::delete-value-creation-error ctx]}}))
